import styled from "styled-components";
import { paragraphSize } from "../utils";
import Icon from "../../../components/icon";

export const Container = styled.div`
  height: 100vh;
  min-height: 100%;
  box-sizing: border-box;
  background: #000C2A;
`

export const HeaderSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 29px 0;
`

export const IntroductionSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px 0;
`

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`

export const NewParagraph = styled.p`
  font-size: ${props => props.responsive ? paragraphSize(props.size) - 6 : paragraphSize(props.size)}px;
  font-family: "${props => props.type || 'Nunito'}", sans-serif;
  font-weight: ${props => props.weight || 400};
  text-align: ${props => props.align || 'center'};
  font-style: normal;
  color: ${props => props.color || '#fff'};
  line-height: 27px;

  @media (min-width: 1366px) {
    font-size: ${props => paragraphSize(props.size)}px;
  }

  @media (max-width: 724px) {
    font-size: ${props => props.responsive ? paragraphSize(props.size) - 8 : paragraphSize(props.size)}px;
  }
`

export const SliderSection = styled.div`
  background: #000;
  height: 100%;
  background: url('/assets/fundo_trees.jpg');
  background-size: 100% 100%; 
  background-repeat: no-repeat;

  //@media (max-width: 500px) {
  //  height: 140vh;
  //}
  //
  //@media (max-width: 1024px) {
  //  height: 130vh;
  //}
  //
  //@media (min-width: 1660px) {
  //  height: 70vh;
  //}
`

export const SliderPart = styled.div`
  margin-top: 6em;
`

export const SliderContainer = styled.div`
  margin: 2em auto 0 auto;
  width: 85%;
  
  .slick-dots {
    bottom: -50px;
    
    button:not(.slick-active)::before {
      color: #fff;
      opacity: 1;
    }

    .slick-active button::before {
      color: #FF5227;
    }
  }

  @media (min-width: 1660px) {
    width: 70%;
  }

  @media (min-width: 1366px) and (max-width: 1600px) {
    position: relative;
    width: 90%;
  }

  @media (max-width: 1023px) {
    position: relative;
    width: 80%;
  }

  @media (min-width: 1024px) and (max-width: 1365px) {
    position: relative;
    width: 85%;
  }
`

export const SimulationCard = styled.div`
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  width: 80%!important;
  margin: 0 20px;

  @media (max-width: 500px) {
    position: relative;
    width: 100%;
  }
`

export const SliderArrow = styled.div`
  position: absolute;
  width: 16px;
  top: 44%;
  right: 34px;
  opacity: 1;
  z-index: 9;
  cursor: pointer;
  fill: #FF5227;

  &.hide {
    display: none;
  }

  ${(props) =>
    props.isPrev &&
    `
      left: 34px;

      > svg {
        transform: rotate(180deg);
      }
    `};

  @media (max-width: 1365px) {
    right: 8px;

    ${(props) =>
      props.isPrev &&
      `
      left: 8px;
    `};
  }
`;

export const FooterButton = styled.button`
  width: 100%;
  height: 38px;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 24px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-align: center;

  &.simulado {
    border: none;
    background: #1B229F;
    color: #ffffff;

    &:disabled {
      background: #1B229F66;
      cursor: not-allowed;
    }
  }
`;

export const SocialIcon = styled(Icon)`
  fill: ${(props) => props.color};
  margin-right: 10px;
`;